import { useState } from 'react';
import { Button, ConfirmDialog } from '../../components';
import { useSession } from '../../lib/auth/useSession';
import { notify } from '../../services/notify';
import { useSetProfileDemo } from './queries';

/**
 * Set / unset Test/Demo, shared by the Chef and Eater dialogs (Notes tab):
 * confirm, then `POST /admin/profiles/{id}/demo`. A demo account leaves the
 * Chefs and Eaters lists (it shows under Eaters → Test/Demo); its orders and
 * money still count everywhere else.
 */
export function DemoProfileButton({ profileId, demo, noun }: { profileId: string; demo: boolean; noun: string }) {
  const [confirming, setConfirming] = useState(false);
  const save = useSetProfileDemo(profileId);
  const { locked } = useSession();
  const next = !demo;

  return (
    <>
      <Button variant="ghost-dark" size="sm" lockedReason={locked('crm.write')} onClick={() => setConfirming(true)}>
        {demo ? 'Unset Test/Demo' : 'Set as Test/Demo'}
      </Button>
      {confirming && (
        <ConfirmDialog
          title={demo ? `Unset Test/Demo on this ${noun}?` : `Set this ${noun} as Test/Demo?`}
          body={
            demo
              ? 'The account goes back into the Chefs and Eaters lists.'
              : 'The account leaves the Chefs and Eaters lists (find it under Eaters → Test/Demo). Its orders and money still count everywhere else.'
          }
          confirmLabel={demo ? 'Unset Test/Demo' : 'Set as Test/Demo'}
          busy={save.isPending}
          onClose={() => setConfirming(false)}
          onConfirm={() =>
            save.mutate(next, {
              onSuccess: () => {
                notify.success(next ? 'Set as Test/Demo.' : 'Test/Demo unset.');
                setConfirming(false);
              },
            })
          }
        />
      )}
    </>
  );
}
